import { Image } from "react-native";
const getImageSize = async (uri: string) => {
	const { width, height } = await new Promise<{ width: number; height: number }>(
		(resolve, reject) => {
			Image.getSize(
				uri,
				(width, height) => {
					resolve({ width, height });
				},
				(err) => {
					reject(err);
				},
			);
		},
	);
	return { width, height };
};

export default getImageSize;
